export const ACTIVE_ORGANIZATION_KEY = 'cromaos.activeOrganization'
export const SELECTED_PLAN_PRICE_KEY = 'cromaos.selectedPlanPrice'
const LEGACY_ACTIVE_ORGANIZATION_KEY = 'studioos.activeOrganization'

export function migrateBrandStorage() {
  const current = localStorage.getItem(ACTIVE_ORGANIZATION_KEY)
  const legacy = localStorage.getItem(LEGACY_ACTIVE_ORGANIZATION_KEY)

  if (!current && legacy) localStorage.setItem(ACTIVE_ORGANIZATION_KEY, legacy)
  if (legacy) localStorage.removeItem(LEGACY_ACTIVE_ORGANIZATION_KEY)
}
